import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import './registerServiceWorker'
import VueCookie from 'vue-cookie'
import i18n from '@/utils/i18n'
import store from './store/store'
import './assets/css/style.css'
import './assets/css/style.scss'
import "./assets/css/product-list.scss";
import LazyLoadDirective from "./assets/js/LazyLoadDirective";
import InfiniteLoading from 'vue-infinite-loading';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Vue.use(InfiniteLoading);
Vue.use(VueCookie);
Vue.config.productionTip = false;
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
const firebase = require("firebase/app");
require('firebase/database')
Vue.directive("lazyload", LazyLoadDirective);
window.__native_money91 = {}
window._JWT = {}
window.Cstmbeforeinstallprompt = {}
var config = {
  apiKey: "AIzaSyAe8pRAGGMUBOplBnnVa0lnrLkxFO1Mkk4",
  authDomain: "mall91-dc1cf.firebaseapp.com",
  databaseURL: "https://mall91-dc1cf.firebaseio.com/", //: https://coupleapp-1154-e31f5.firebaseio.com/ https://coupleapp-1154.firebaseio.com/
  storageBucket: "bucket-mall91.appspot.com",
  projectId: 'mall91-dc1cf'
};
if(!window.location.hostname == "localhost"){
  Sentry.init({
    dsn: 'https://d376ccd2ad9a4372bb8d5466de942335@sentry.services-money91.com/10',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
  Sentry.setUser({"id": VueCookie.get("X-Auth-Id")});
}
firebase.initializeApp(config);
var database = firebase.database();
Vue.prototype.database = database
export const bus = new Vue()
new Vue({
  i18n,
  store,
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
